import React from "react";
import About from "../components/About/About";
import Navbar from "../components/Home/Navbar";

function AboutPage() {
  return (
    <>
      <Navbar />
      <About />
    </>
  );
}

export default AboutPage;
